import React from "react";
import { Layout, Spin, Icon, BackTop } from "antd";
import "antd/dist/antd.css";
import "./articles.css";
import ArticleBlock from "../articleblocl/ArticleBlock";
import ArticleDetails from "../articleDetails/ArticleDetails";
import PubmedService from "../../services/pmService";
import InfiniteScroll from "react-infinite-scroller";

export default class Articles extends React.Component {
  pmService = new PubmedService();

  state = {
    news: [],
    isLoading: true,
    selectArticle: null,
    nextPageCursor: "",
    query: null,
  };

  componentDidMount() {
    this.getData();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ isLoading: true, selectArticle: null });
      this.pmService.EBIFetch(this.props.value).then(body => {
        const cursor = body[0].cursor;
        const query = body[0].query;
        this.setState({
          nextPageCursor: cursor,
          query,
          news: body,
          isLoading: false,
        });
      });
    }
  }

  loadArticles = () => {
    this.pmService
      .EBIFetch(this.state.query, this.state.nextPageCursor)
      .then(body => {
        const New = [...this.state.news, ...body];
        const cursor = body[0].cursor;
        const query = body[0].query;
        this.setState({
          nextPageCursor: cursor,
          query,
          news: New,
          isLoading: false,
        });
      });
  };

  getData() {
    this.pmService.EBIFetch("Glycine").then(body => {
      const cursor = body[0].cursor;
      const query = body[0].query;
      this.setState({
        nextPageCursor: cursor,
        query,
        news: body,
        isLoading: false,
      });
    });
  }

  selectArticleData = data => {
    this.setState({ selectArticle: data });
  };
  render() {
    const selectArticleData = this.selectArticleData;
    const antIcon = <Icon type="loading" style={{ fontSize: 44 }} spin />;
    if (this.state.isLoading) {
      return (
        <div className="spiner">
          <Spin indicator={antIcon} />
        </div>
      );
    }
    if (this.state.selectArticle) {
      return (
        <ArticleDetails
          select={selectArticleData}
          data={this.state.selectArticle}
          addFavorite={this.props.addFavorite}
        />
      );
    }
    const news = this.state.news.concat().map(function(item, i) {
      return <ArticleBlock data={item} key={i} select={selectArticleData} />;
    });

    return (
      <Layout className="bodyContainer">
        <div>
          <BackTop />
          <strong style={{ color: "rgba(24, 64, 64, 0.6)" }}> </strong>
        </div>
        <Layout className="bodyContainer">
          <InfiniteScroll
            key="1080"
            initialLoad={false}
            pageStart={0}
            loadMore={this.loadArticles}
            hasMore={this.state.news.length < 10 ? false : true}
            loader={
              <div key={Math.floor(Math.random() * 42)} className="spiner">
                <Spin indicator={antIcon} />
              </div>
            }
          >
            {news}
          </InfiniteScroll>
        </Layout>
      </Layout>
    );
  }
}
